import { useAuthUser } from "@data/auth";
import { Button, Divider, Typography } from "@dm-4dev/ui";
import { useMainMenu } from "@route/layout/lib/use-menu";
import clsx from "clsx";
import { UserCircle2Icon, XIcon } from "lucide-react";

export interface LeftMenuMobileProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LeftMenuMobile = ({ isOpen, onClose }: LeftMenuMobileProps) => {
  const mainMenu = useMainMenu();
  const { userData } = useAuthUser();
  return (
    <>
      {isOpen && (
        <button
          className="fixed z-40 inset-0 backdrop-brightness-75 backdrop-blur-sm flex items-center justify-center"
          onClick={onClose}
        />
      )}
      <div
        className={clsx(
          "bg-white fixed z-50 bottom-0 top-0 transition-all delay-0 duration-500 md:max-w-80 max-w-[65vw] w-full shadow-xl",
          {
            "left-0": isOpen,
            "-left-full": !isOpen
          }
        )}
      >
        <div className="flex justify-between items-center px-2 md:px-6 py-3">
          <div className="flex gap-3 items-center">
            <UserCircle2Icon size={44} className="text-gray-400" />
            <div className="flex flex-col gap-1 items-start">
              <Typography variant="subheading" className="text-primary font-bold">
                {userData?.displayName}
              </Typography>
            </div>
          </div>
          <Button variant="text" startIcon={<XIcon className="text-gray-500" />} onClick={() => onClose()} />
        </div>
        <Divider />
        <div className="p-2 md:p-4 flex flex-col gap-4 items-start">
          {mainMenu.map((item) => (
            <Button
              key={item.label}
              {...item.buttonProps}
              onClick={(e) => {
                if (item?.buttonProps?.onClick) item.buttonProps.onClick(e);
                onClose();
              }}
            >
              {item.label}
            </Button>
          ))}
        </div>
      </div>
    </>
  );
};
